import {PartUnitApiDto} from "./_RestModels";

export default class PartUnit {
    constructor(public readonly id: string, public readonly nameEn: string, public readonly namePl: string, public readonly displayName: string) {
    }

    public static fromJson(json: PartUnitApiDto): PartUnit {
        return new PartUnit(json.id, json.nameEn, json.namePl, json.displayName);
    }
}